export const initialCreateEventState = {
  title: "",
  subtitle: "",
  description: "",
  imageFile: null,
  imageData: null,
  bannerFile: null,
  bannerData: null,
  url: "",
  eventDate: "",
  tags: "",
  visibility: "",
  imageAttribute: {
    shape: "SQUARE",
    radius: 0,
    x: 0,
    y: 0,
    height: 100,
    width: 100,
    position: "north_west",
  },
  nameAttribute: {
    x: 0,
    y: 0,
    height: 46,
    width: 400,
    position: "north_west",
    fontFamily: { name: "Expose", value: "Expose.ttf" },
    fontSize: { name: "26", value: "26" },
    fontWeight: "",
    fontStyle: "",
    textTransform: "",
    textColor: "",
    textAlign: "",
  },
  sampleUsername: "",
  hideUsername: false,
};
